"use client";

import { useIsDark } from "@/context/ThemeContext";
import { twMerge } from "tailwind-merge";

export default function WebLayout({ children }) {
    const isdark = useIsDark();
  return (
    <div>
      {/* left top  */}
      <section className="relative translate-x-0 -translate-y-50 xl:translate-y-0">
      <div className={twMerge("absolute top-[500px] left-[-63px] w-[313px] h-[272px] rounded-full rotate-126 blur-[100px]",  isdark ? "bg-[#8593E8] opacity-40" : "bg-[#A1ADF5] opacity-60")}/>
      <div className={twMerge("absolute top-[700px] left-[-244px] w-[315px] h-[275px] rounded-full  rotate-126 blur-[120px]", isdark ? "bg-[#5D6EF3] opacity-40" : "bg-[#2A40E7] opacity-40")}/>
      <div className={twMerge("absolute top-[900px] left-[-260px] w-[300px] h-[262px] rounded-full rotate-126 blur-[100px]",isdark ? "bg-[#FC4FF6] opacity-20" : "bg-[#FF8DFB] opacity-60")}/>
      </section>

        {/* right middle */}
      <section className="block relative -translate-y-350 lg:-translate-y-280 xl:translate-y-0">
        <div
          className={twMerge(
            "absolute top-[1032px] right-[-150px] w-[274px] h-[315px] rounded-full -rotate-120 blur-[120px]",
            isdark ? "bg-[#5D6EF3] opacity-20" : "bg-[#2A40E7] opacity-40"
          )}
        />
        <div
          className={twMerge(
            "absolute top-[1200px] right-[-154px] w-[262px] h-[300px] rounded-full -rotate-120 blur-[100px]",
            isdark ? "bg-[#FC4FF6] opacity-20" : "bg-[#FF8DFB] opacity-60"
          )}
        />
      </section>

        {/* left bottom */}
      {/* <section className="relative translate-x-0 md:-translate-y-220 xl:translate-y-0">
      <div className={twMerge("absolute top-[2710px] left-[-112px] w-[300px] h-[262px] rounded-full rotate-126 opacity-40 blur-[100px]",isdark ? "bg-[#FC4FF6]" : "bg-[#FF8DFB] ")}/>
      <div className={twMerge("absolute top-[2932px] left-[-159px] w-[313px] h-[272px] rounded-full rotate-126 opacity-40 blur-[120px]",  isdark ? "bg-[#5D6EF3]" : "bg-[#2A40E7]")}/>
      <div className={twMerge("absolute top-[3105px] left-[-231px] w-[315px] h-[275px] rounded-full  rotate-126 opacity-40 blur-[100px]", isdark ? "bg-[#8593E8]" : "bg-[#A1ADF5]")}/>
      </section> */}

      <div className="">{children}</div>
    </div>
  );
};
